import { ResourceOptions } from 'react-admin';
import { MdOutlineFactCheck } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';
export { RECONCILIATION_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultReconciliation;
export const icon = MdOutlineFactCheck;
export const options: ResourceOptions = {
  label: 'module.vaultReconciliation.title',
};
